import React from "react";
import List from "../components/inputs/List";
import PROJECT_CONFIG from "../config/projectConfig";

const Resources = () => {
  return (
    <div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="rounded-lg shadow-sm p-8">
          <h1 className="text-4xl font-bold text-gray-900 mb-8">Resources</h1>

          {/* Resources List */}
          <div className="mb-8">
            <List
              items={[
                '<a href="https://www.fema.gov/flood-insurance/rules-legislation/laws" target="_blank" rel="noopener noreferrer" class="hover:text-custom-blue hover:underline">National Flood Insurance Act</a>',
                '<a href="https://www.fema.gov/flood-insurance" target="_blank" rel="noopener noreferrer" class="hover:text-custom-blue hover:underline">National Flood Insurance Program</a>',
                '<a href="https://www.fema.gov/about/contact" target="_blank" rel="noopener noreferrer" class="hover:text-custom-blue hover:underline">National Flood Insurance Program Regional Offices</a>',
                '<a href="https://www.floodsmart.gov/why-buy-flood-insurance" target="_blank" rel="noopener noreferrer" class="hover:text-custom-blue hover:underline">National Flood Insurance Program | Flood Insurance</a>',
                '<a href="https://www.fema.gov/flood-maps/tutorials#nfip" target="_blank" rel="noopener noreferrer" class="hover:text-custom-blue hover:underline">NFIP Tutorials | Tutorials | FEMA.gov</a>',
                '<a href="https://www.ecfr.gov/current/title-44/chapter-I/subchapter-B/part-67?toc=1" target="_blank" rel="noopener noreferrer" class="hover:text-custom-blue hover:underline">National Flood Insurance Program | 42 U.S. Code § 4104</a>',
                '<a href="#" class="hover:text-custom-blue hover:underline">FEMA Map Service Center</a>',
                '<a href="#" class="hover:text-custom-blue hover:underline">FEMA Guidelines and Standards for Flood Risk Analysis and Mapping</a>',
                '<a href="#" class="hover:text-custom-blue hover:underline">USC 42, Chapter 50 - National Flood Insurance</a>',
              ]}
              variant="primary"
              withMargin
            />
          </div>

          {/* Community Resources Section */}
          <div>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">
              Community Resources
            </h2>
            <List
              items={[
                `<a href="http://18.220.42.26/floodsrp/web/sites/default/files/2023-04/${PROJECT_CONFIG.name}_Overview.pdf" target="_blank" rel="noopener noreferrer" class="hover:text-custom-blue hover:underline">${PROJECT_CONFIG.name} Overview (PDF)</a>`,
                `<a href="#" class="hover:text-custom-blue hover:underline">${PROJECT_CONFIG.name} Request Form (PDF and MS Word)</a>`,
                `<a href="#" class="hover:text-custom-blue hover:underline">${PROJECT_CONFIG.name} Community Submittal Agreement (PDF)</a>`,
              ]}
              variant="primary"
              withMargin
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Resources;
